/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_LOCATION_TYPES_START, GET_LOCATION_TYPES_SUCCESS, GET_LOCATION_TYPES_FAILURE } from './types';
import { ILocationType } from '../../models/Locations/Locations';

export const initialState: { entities: ILocationType[]; isLoading: boolean; error: string | undefined } = {
  entities: [],
  isLoading: true,
  error: undefined
};

export const locationTypesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_LOCATION_TYPES_START:
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    case GET_LOCATION_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.locationTypes,
        error: undefined
      };
    case GET_LOCATION_TYPES_FAILURE:
      return {
        ...state,
        isLoading: false,
        entities: [],
        error: action.error
      };
    default:
      return state;
  }
};
